/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC, useCallback, ReactNode, useMemo } from "react";

import useWatchState from "../../../hooks/useWatchState";

export interface IOptionSelector {
  /** Set initially selected option (could ne none) */
  selectedItem?: string | number;
  children?: ReactNode;
  /** On option select callback */
  onChange?(id: string | number): void;
}

export const OptionSelectorContext = React.createContext<IOptionSelector>({
  selectedItem: null,
  onChange: null,
});

const OptionSelector: FC<IOptionSelector> = ({
  selectedItem,
  onChange,
  children,
}) => {
  const [valueState, setSelectedValue] = useWatchState<string | number>({
    value: selectedItem,
  });

  const changeHandler = useCallback(
    (id: string | number) => {
      onChange && onChange(id);
      setSelectedValue(id);
    },
    [onChange, setSelectedValue],
  );

  const context = useMemo(
    () => ({
      selectedItem: valueState,
      onChange: changeHandler,
    }),
    [changeHandler, valueState],
  );

  return (
    <OptionSelectorContext.Provider value={context}>
      {children}
    </OptionSelectorContext.Provider>
  );
};

export default OptionSelector;
